module.exports = __webpack_public_path__ + "img/maintenance.f4a2ecfd.png";